module.exports = __webpack_public_path__ + "static/media/chef3.da5e046b.jpg";